import { PopConfirm } from "../../core-ui/components/PopConfirm/PopConfirm";
import { Text } from "../../core-ui/components/Text/Text";
import { Button, ButtonVariant } from "../../core-ui/components/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkSlash } from "@fortawesome/sharp-solid-svg-icons";

interface MusoCreditsUnLinkAccountButtonProps {
  onClick: () => void;
}

export const MusoCreditsUnLinkAccountButton = ({
  onClick,
}: MusoCreditsUnLinkAccountButtonProps) => {
  return (
    <PopConfirm
      title="Unlink Muso Account"
      onConfirm={async () => await onClick()}
      description={
        <Text>
          Are you sure you want to unlink your Muso account from EngineEars?
          Your credits will no longer be shared on your profile.
        </Text>
      }
    >
      <Button
        startIcon={<FontAwesomeIcon icon={faLinkSlash} />}
        variant={ButtonVariant.DELETE}
      >
        Unlink Muso Account
      </Button>
    </PopConfirm>
  );
};
